import { withMask } from "use-mask-input";
import { validateDob } from "@/utils/validateField/dob";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { Button } from "@/pages/quiz/15000/components/Button";
import { Input } from "@/pages/quiz/15000/components/Input";

type FormFieldName = "dob";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  dob: {
    customValidator: (v: string) => validateDob(v || ""),
    required: true,
  },
};

const ContactDob = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, onValidateForm, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 1;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <Input
        {...registerField("dob")}
        ref={withMask("99/99/9999", {
          jitMasking: true,
          showMaskOnHover: false,
        })}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="MM/DD/YYYY"
        errorMessage={error?.dob}
      />

      <Button disabled={!isFormAnswered} onClick={onValidateForm(onSubmit)} />
    </>
  );
};

export { ContactDob };
